<div class="card mb-3" data-cy="my-claimed-tasks">
	<div class="mb-3">
		<div class="flex align-items-center mb-3">
			<h4>Claimed Tasks</h4>
			<div class="flex gap-3 ml-auto w-fit">
				<p-calendar
					(onSelect)="onDateChange()"
					[(ngModel)]="selectedDate"
					[maxDate]="maxDate"
					class="calendar-input"
					dateFormat="dd/mm/yy"
					showIcon
				></p-calendar>

				<button
					(click)="goToTaskCalendar()"
					[style]="{ 'max-width': '110px' }"
					class="p-button-primary"
					icon="pi pi-calendar"
					label="Calendar"
					pButton
				></button>
			</div>
		</div>
	</div>

	<div class="flex justify-content-center gap-2 mb-2">
		<div>
			<i (click)="decreaseTilesInView()" class="pi pi-chevron-up cursor-pointer" title="Show Less"></i>
		</div>
	</div>

	<div class="claimed-tasks-container custom-card cursor-pointer">
		<div *ngIf="isLoading" class="no-tasks-message">Loading...</div>

		<ng-container *ngIf="!isLoading">
				<div *ngIf="!isLoading && dataLoaded && claimedTasks.length === 0" class="no-tasks-message">
					<p>No tasks available for the selected date range.</p>
				</div>

				<div data-cy="slider-container" *ngIf="!isLoading && claimedTasks.length > 0" class="slider-container">
					<button (click)="moveLeft()" class="slider-button cursor-pointer" icon="pi pi-chevron-left" pButton></button>

					<div #tileContainer class="tile-container">
						<div (click)="onTaskClick(task)"
								 *ngFor="let task of claimedTasks.slice(visibleStartIndex, visibleStartIndex + tilesInView)"
								 [ngClass]="{ 'highlighted-task': isSelectedTask(task) }"
								 class="task-item"
						>

							<span class="task-date">
								{{ task.start | DateLocalFormat: false  }}
							</span>

							<div
								[ngClass]="{
									'bg-danger': task.className === 'day-cell-overdue',
									'bg-warning': task.className === 'day-cell-normal',
									'bg-success': task.className === 'day-cell-complete'
								}"
								class="task-status"
							>
								<i
									[ngClass]="{
										'pi-exclamation-circle': task.className === 'day-cell-overdue',
										'pi-check-circle': task.className === 'day-cell-complete',
										'pi-cog': task.className === 'day-cell-normal'
									}"
									class="pi"
								></i>
							</div>

							<div class="task-metrics">
								<div class="metric-dot workflow-dot-daily">{{ task.extendedProps.dailyCount }}</div>
								<div class="metric-dot workflow-dot-non-daily">{{ task.extendedProps.nonDailyCount }}</div>
								<div data-cy="task-metric-form-count" *ngIf="this.userPermissions.forms.read" class="metric-dot form-dot">{{ task.extendedProps.formCount }}</div>
							</div>
						</div>
					</div>

					<button (click)="moveRight()" class="slider-button cursor-pointer" icon="pi pi-chevron-right"
									pButton></button>
				</div>
			</ng-container>
	</div>

	<div class="flex justify-content-center mt-2">
		<div>
			<i (click)="increaseTilesInView()" class="pi pi-chevron-down cursor-pointer" title="Show Less"></i>
		</div>
	</div>
</div>
